const news = [
    {
        path: '/newsMain',
        name: 'newsMain',
        redirect: '/newsList',
        meta: { breadcrumb: '新闻中心' },
        component: () => import('@/views/news/NewsMain.vue'),
        children: [
            {
                path: '/newsList',
                name: 'newsList',
                meta: { breadcrumb: '新闻列表' },
                component: () => import('@/views/news/pages/NewsList.vue')
            }, {
                path: '/newsDetail',
                name: 'newsDetail',
                meta: { breadcrumb: '新闻详情' },
                component: () => import('@/views/news/pages/NewsDetail.vue')
            }
        ]
    }
]

export default news